const menus = [
  {
    id: "bank",
    text: "App - Ngân Hàng",
    path: "/bank",
    subMenu: null,
    isAdmin: false,
  },
  {
    id: "transaction-history",
    text: "Lịch sử chi tiêu",
    path: "/transaction/history",
    subMenu: null,
    isAdmin: false,
  },
  {
    id: 'deposit',
    text: 'Nạp Tiền',
    path: '/payment/deposit',
    subMenu: null,
    isAdmin: false,
  },
  {
    id: 'app-guide',
    text: 'Tải App & Hướng dẫn',
    path: '/app-guide',
    subMenu: null,
    isAdmin: false,
  },
  {
    id: 'xsmb',
    text: 'Xác xuất XSMB',
    path: '/xsmb',
    subMenu: null,
    isAdmin: false,
  },
];

export default menus;
